"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isIE_1 = require("./isIE");
var polyfill = function (x) {
    x = +x;
    if (x === 0 || isNaN(x)) {
        return x;
    }
    return x > 0 ? 1 : -1;
};
exports.mathSign = isIE_1.isIE() ? polyfill : Math.sign;
//# sourceMappingURL=mathSign.js.map